import { useMutation } from '@apollo/client';
import { Checkbox, Form, Input, Modal } from 'antd';
import React, { useEffect, useRef } from 'react';
import { REGEX } from '../../../common/constants';
import { ADD_ENV_KEYS } from '../graphql/Mutations';

const initialValues = {
  name: '',
  value: '',
  isPrivate: false,
};

export default function AddKeyModal({
  visible,
  setVisible,
  topicId,
  refetchEnvKeyValueData,
}) {
  const [form] = Form.useForm();
  const inputRef = useRef(null);

  const [addEnvKey, { loading }] = useMutation(ADD_ENV_KEYS, {
    onCompleted() {
      refetchEnvKeyValueData();
      form?.resetFields();
      setVisible(false);
    },
    onError() {},
  });

  const onFinish = (values) => {
    addEnvKey({
      variables: {
        data: {
          ...values,
          projectTopicId: topicId,
        },
      },
    });
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event?.key === 'Enter' && visible) {
        event?.preventDefault();
        form?.submit();
      }
    };

    // eslint-disable-next-line no-undef
    document?.addEventListener('keydown', handleKeyDown);
    return () => {
      // eslint-disable-next-line no-undef
      document?.removeEventListener('keydown', handleKeyDown);
    };
  }, [visible]);

  return (
    <Modal
      open={visible}
      centered
      title="Create a new key"
      onOk={() => {
        form?.submit();
      }}
      onCancel={() => {
        setVisible(false);
        form?.resetFields();
      }}
      okText="Add"
      okButtonProps={{ loading }}
      afterOpenChange={(open) => {
        if (open) {
          inputRef?.current?.focus();
        }
      }}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={initialValues}
      >
        <Form.Item
          label="Key Name"
          name="name"
          rules={[
            {
              required: true,
              message: 'Please enter key name',
            },
            {
              pattern: REGEX?.CAPITAL_LETTER_AND_NUMBER_WITH_NO_BLANK_SPACE,
              message:
                'Key must only contain uppercase letters and underscores, with no spaces',
            },
          ]}
        >
          <Input ref={inputRef} />
        </Form.Item>
        <Form.Item label="Key Value" name="value">
          <Input />
        </Form.Item>
        <Form.Item label="Key Type" name="isPrivate" valuePropName="checked">
          <Checkbox>Is Private</Checkbox>
        </Form.Item>
      </Form>
    </Modal>
  );
}
